export const TOGGLE_DELETE_SEGMENT_GROUP_MODAL = "TOGGLE_DELETE_SEGMENT_GROUP_MODAL";
export const TOGGLE_RENAME_SEGMENT_GROUP_MODAL = "TOGGLE_RENAME_SEGMENT_GROUP_MODAL";
export const REQUEST_SEGMENTS_DATA = "REQUEST_SEMGENTS_DATA";
export const DELETE_SEGMENT_DATA = "DELETE_SEGMENT_DATA";
export const RECEIVE_SEGMENTS_DATA = "RECEIVE_SEMGENTS_DATA";
export const UPDATE_SEGMENT_DATA = "UPDATE_SEGMENT_DATA";
